import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { sortDayOfferLabel } from 'shared/models/static-list-data.service';

@Component({
  selector: 'app-sort-by-offer-lookup',
  templateUrl: './sort-by-offer-lookup.component.html',
  styleUrls: ['./sort-by-offer-lookup.component.css']
})
export class SortByOfferLookupComponent implements OnInit {

  @Input() set resetData(isClear) {
    if (isClear) {
      this.sortByOfferSelected = 'date';
    }
  }
  @Input() placeholder = 'Sort By';
  @Input() isdisabled = false;
  @Input() filterObjValue = 'sortByWorkOffer';
  @Input() isMultipleSelected = false;
  @Input() viewType = '';

  @Output() getSortByOfferObj: EventEmitter<any> = new EventEmitter;


  sortByOfferOptionList = [];
  sortByOfferSelected = 'date';
  sortDirection: 'asc' | 'desc' = 'asc';
  /**
   * @constructor
   * Represents a SortByOfferLookupComponent.
   */
  constructor() {
  }

  ngOnInit() {
    this.sortByOfferOptionList = sortDayOfferLabel;
    const preselected = localStorage.getItem('filterObj') ? JSON.parse(localStorage.getItem('filterObj')) : '';
    this.sortByOfferSelected = (preselected && preselected[this.filterObjValue] && preselected[this.filterObjValue][0]) ? preselected[this.filterObjValue][0]['sortBy'] : 'date';
    this.sortDirection = (preselected && preselected[this.filterObjValue] && preselected[this.filterObjValue][0]) ? preselected[this.filterObjValue][0]['direction'] : 'asc';
  }

  onSortByOfferChange() {
     this.applySorting();
  }

  clearSortByOffer() {
    this.sortByOfferSelected = 'date';
    this.getSortByOfferObj.emit([]);
  }

  setSortDirection(dir) {
    this.sortDirection = dir;
    this.applySorting();
  }


  applySorting() {
    this.getSortByOfferObj.emit([{ sortBy: this.sortByOfferSelected, direction: this.sortDirection }]);
  }

}
